import { createContext } from "react";

interface IBaseLayoutContext {
  setNoRowsInList: (value: boolean) => void;
  buttonSettings: {
    btnIcon?: React.ReactNode;
    btnText?: string;
    btnOnClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    btnLink?: string;
  };
}

export const BaseLayoutContext = createContext<IBaseLayoutContext | null>(null);
